<template>
    <div class="h-full pt-3 flex flex-col items-center justify-between">

        <div class="">
            <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900" :class="isUrl('') ? 'text-white' : ''">
                <inertia-link
                    class="flex items-center 400 py-2 focus:text-white hover:text-white"
                    :class="isUrl('') ? 'font-semibold text-white' : 'group text-teal-400'"
                    :href="route('admin.dashboard')"
                >
                    <i class="fa-fw fa-tachometer-alt mr-2" :class="isUrl('') ? 'far' : 'fal'"></i>
                    <div class="hidden md:block">Dashboard</div>
                </inertia-link>
            </div>

            <div class="mt-3 pt-3 mx-5 border-t border-teal-900 "></div>

            <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900" :class="isUrl('joboffers') ? 'text-white' : ''">
                <inertia-link
                    class="flex items-center group py-2 focus:text-white hover:text-white"
                    :class="isUrl('joboffers') ? 'font-semibold text-white' : 'text-teal-400'"
                    :href="route('admin.joboffers.index')"
                >
                    <i class="fa-fw fa-file-user mr-2" :class="isUrl('joboffers') ? 'far' : 'fal'"></i>
                    <div class="hidden md:block">Vacatures</div>
                </inertia-link>
            </div>

            <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900" :class="isUrl('users') ? 'text-white' : ''">
                <inertia-link
                    class="flex items-center group py-2 focus:text-white hover:text-white"
                    :class="isUrl('users') ? 'font-semibold text-white' : 'text-teal-400'"
                    :href="route('admin.users.index')"
                >
                    <i class="fa-fw fa-users mr-2" :class="isUrl('users') ? 'far' : 'fal'"></i>
                    <div class="hidden md:block text-sm">Wekzoekenden</div>
                </inertia-link>
            </div>

            <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900" :class="isUrl('companies') ? 'text-white' : ''">
                <inertia-link
                    class="flex items-center group py-2 focus:text-white hover:text-white"
                    :class="isUrl('companies') ? 'font-semibold text-white' : 'text-teal-400'"
                    :href="route('admin.companies.index')"
                >
                    <i class="fa-fw fa-building mr-2" :class="isUrl('companies') ? 'far' : 'fal'"></i>
                    <div class="hidden md:block">Bedrijven</div>
                </inertia-link>

                <inertia-link
                    class="flex items-center group py-2 focus:text-white hover:text-white"
                    :class="isUrl('company-users') ? 'font-semibold text-white' : 'text-teal-400'"
                    :href="route('admin.company-users.index')"
                >
                    <!-- <i class="fa-fw fa-users mr-2" :class="isUrl('users') ? 'far' : 'fal'"></i> -->
                    <div class="hidden md:block ml-8">Gebruikers</div>
                </inertia-link>
            </div>




            <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900" :class="isUrl('blog') ? 'text-white' : ''">
                <inertia-link
                    class="flex items-center group py-2 focus:text-white hover:text-white"
                    :class="(isUrl('blog') && !isUrl('blogcategories')) ? 'font-semibold text-white' : 'text-teal-400'"
                    :href="route('admin.blogs.index')"
                >
                    <i class="fa-fw fa-newspaper mr-2" :class="(isUrl('blog') && !isUrl('blogcategories')) ? 'far' : 'fal'"></i>
                    <div class="hidden md:block">Blog</div>
                </inertia-link>

                <inertia-link
                    class="flex items-center group py-2 focus:text-white hover:text-white"
                    :class="isUrl('blogcategories') ? 'font-semibold text-white' : 'text-teal-400'"
                    :href="route('admin.blogcategories.index')"
                >
                    <!-- <i class="fa-fw fa-newspaper mr-2 fal"></i> -->
                    <div class="hidden md:block ml-8">rubrieken</div>
                </inertia-link>
            </div>

            <div class="mt-3 pt-3 mx-5 border-t border-teal-900 "></div>


            <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900" :class="isUrl('places') ? 'text-white' : ''">
                <inertia-link
                    class="flex items-center group py-2 focus:text-white hover:text-white"
                    :class="isUrl('places') ? 'font-semibold text-white' : 'text-teal-400'"
                    :href="route('admin.places.index')"
                >
                    <i class="fa-fw fa-building mr-2" :class="isUrl('places') ? 'far' : 'fal'"></i>
                    <div class="hidden md:block">Plaatsen</div>
                </inertia-link>
            </div>

            <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900" :class="isUrl('tags') ? 'text-white' : ''">
                <inertia-link
                    class="flex items-center group py-2 focus:text-white hover:text-white"
                    :class="isUrl('tags') ? 'font-semibold text-white' : 'text-teal-400'"
                    :href="route('admin.tags.index')"
                >
                    <i class="fa-fw fa-tags mr-2" :class="isUrl('tags') ? 'fad' : 'fad'"></i>
                    <div class="hidden md:block">Tags</div>
                </inertia-link>
            </div>

            <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900" :class="isUrl('jobtemplates') ? 'text-white' : ''">
                <inertia-link
                    class="flex items-center group py-2 focus:text-white hover:text-white"
                    :class="isUrl('jobtemplates') ? 'font-semibold text-white' : 'text-teal-400'"
                    :href="route('admin.jobtemplates.index')"
                >
                    <i class="fa-fw fa-user-md mr-2" :class="isUrl('tags') ? 'fad' : 'fad'"></i>
                    <div class="hidden md:block">Banen</div>
                </inertia-link>
            </div>

            <div class="mt-3 pt-3 mx-5 border-t border-teal-900 "></div>

            <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900" :class="isUrl('scrapers') ? 'text-white' : ''">
                <inertia-link
                    class="flex items-center group py-2 focus:text-white hover:text-white"
                    :class="isUrl('scrapers') ? 'font-semibold text-white' : 'text-teal-400'"
                    :href="route('admin.scrapers.index')"
                >
                    <i class="fa-fw fa-project-diagram mr-2" :class="isUrl('scrapers') ? 'far' : 'fal'"></i>
                    <div class="hidden md:block">Scrapers</div>
                </inertia-link>
            </div>

            <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900" :class="isUrl('scraperpages') ? 'text-white' : ''">
                <inertia-link
                    class="flex items-center group py-2 focus:text-white hover:text-white"
                    :class="isUrl('scraperpages') ? 'font-semibold text-white' : 'text-teal-400'"
                    :href="route('admin.scraperpages.index')"
                >
                    <i class="fa-fw fa-file-alt mr-2" :class="isUrl('scraperpages') ? 'far' : 'fal'"></i>
                    <div class="hidden md:block">Pages</div>
                </inertia-link>
            </div>

            <div class="mt-3 pt-3 mx-5 border-t border-teal-900 "></div>

            <div class="text-sm">
                <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900">
                    <inertia-link
                        class="flex items-center group text-teal-600 py-2 focus:text-white hover:text-white"
                        :class="isUrl('activitylog') ? 'font-semibold text-white' : 'text-teal-400'"
                        :href="route('admin.activitylog.index')"
                    >
                        <i class="fa-fw fa-book-alt mr-2" :class="isUrl('activitylog') ? 'far' : 'fal'"></i>
                        <div class="hidden md:block">Log</div>
                    </inertia-link>
                </div>
                <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900">
                    <a href="/horizon" target="_blank" class="flex items-center group text-teal-600 py-2 focus:text-white hover:text-white">
                        <i class="fa-fw fa-user-hard-hat mr-2" :class="isUrl('horizon') ? 'far' : 'fal'"></i>
                        <div class="hidden md:block">Horizon</div>
                    </a>
                </div>
                <!-- <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900">
                    <a href="https://www.algolia.com/apps/PU7G5YHVAE/dashboard" target="_blank" class="flex items-center group text-teal-600 py-2 focus:text-white hover:text-white">
                        <i class="fa-fw fa-search mr-2" :class="isUrl('horizon') ? 'far' : 'fal'"></i>
                        <div class="hidden md:block">Algolia</div>
                    </a>
                </div> -->
                <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900">
                    <a
                        href="https://app.bugsnag.com/humboldt-1/humboldt/errors"
                        target="_blank"
                        class="flex items-center group text-teal-600 py-2 focus:text-white hover:text-white"
                    >
                        <i class="fa-fw fal fa-bug mr-2"></i>
                        <div class="hidden md:block">Bugsnag</div>
                    </a>
                </div>
            </div>
            <div class="mt-3 pt-3 mx-5 border-t border-teal-900 "></div>

            <div class="mb-1 px-6 focus-within:bg-teal-900 hover:bg-teal-900 text-teal-400">
                <inertia-link title="Log uit" class="flex items-center  group py-2 focus:text-white hover:text-white" :href="route('admin.logout').url()" method="post" as="button">
                    <i class="fal fa-fw fa-sign-out-alt mr-2"></i>
                    <div class="hidden md:block">{{ $page.props.auth.user.first_name }}</div>
                </inertia-link>
            </div>


        </div>

        <div class="flex-1 flex items-end text-teal-600 mb-10 text-sm" >{{ $page.props.app.server }}</div>

    </div>
</template>

<script>
import Dropdown from "@/admin/Shared/Dropdown";

export default {
    components: {
        Dropdown
    },
    data() {
        return {
            showUserMenu: false
        };
    },

    props: {
        url: String
    },
    methods: {
        isUrl(...urls) {
            if (urls[0] === "") {
                return this.url === "";
            }

            return urls.filter(url => this.url.startsWith(url)).length;
        }
    }
};
</script>
